import React from 'react';
import ReactDOM from 'react-dom';
import './App.css';
import Rigsense from './pages/Rigsense';

async function GoRigsense() {
  ReactDOM.render(
    <React.StrictMode>
      <Rigsense />    
    </React.StrictMode>,
    document.getElementById('root')
  );  
}

/* App()
 * The meat and potatoes of our web-app; where it all comes together
 */
function App() {
  GoRigsense();
  return "";
}
export default App;